// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-item--disabled,.v-item--disabled *{pointer-events:none}", ""]);
// Exports
module.exports = exports;
